<template>
  <div class="container">
    <img class="logo" src="@/assets/images/logo.jpg" />
    <p class="tip">请选择您的登录身份</p>
    <div class="goRegister">
      <div class="icon">
        <img src="@/assets/images/doctor.png" />
      </div>
      <div class="text" @click="goRegister">
        <span class="textBold">医疗相关人士</span>
        <div class="registerBtn">
          <span>去注册</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
    </div>
    <div class="line"></div>
    <!-- <p class="clause">登录即代表同意<span @click="$router.push('/privacyPolicy')">《隐私政策》</span></p> -->
    <div class="btnBox">
      <span class="btn goLogin" @click="goLogin">已有账号去登录</span>
      <span class="btn staffLogin" @click="goStaffLogin">强生员工登录</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import storage from "../../common/utils/storage";
export default {
  name: 'Entrance',
  data() {
    return {}
  },
  computed: {
    ...mapState(['userInfo']),
    sid() {
      return this.$route.query.sid;
    },
    uri() {
      return this.$route.query.uri;
    },
    key() {
      return this.$route.query.key;
    }
  },
  created() {
    console.log(process.env.NODE_ENV)
  },
  methods: {
    goRegister() {
      // this.$router.push('/register');
      storage.setStore('lastPath', '/register');
      storage.setStore('scope', 'snsapi_userinfo');
      if(process.env.NODE_ENV == 'production') {
        this.$router.push({
          path: '/hubAuthorize',
          query: {scope: 'snsapi_userinfo'}
        })
      } else {
        this.$router.push({
          path: '/authorize',
          query: {scope: 'snsapi_userinfo'}
        })
      }
    },
    goLogin() {
      // this.$router.push('/login');
      if(!this.userInfo) {
        storage.setStore('lastPath', '/login');
        storage.setStore('scope', 'snsapi_userinfo');
        if(process.env.NODE_ENV == 'production') {
          this.$router.push({
            path: '/hubAuthorize',
            query: {scope: 'snsapi_userinfo'}
          })
        } else {
          this.$router.push({
            path: '/authorize',
            query: {scope: 'snsapi_userinfo'}
          })
        }
      } else {
        this.$router.push('/login');
      }
    },
    goStaffLogin() {
      if(!this.userInfo) {
        storage.setStore('lastPath', '/JNJUser');
        storage.setStore('scope', 'snsapi_userinfo');
        if(process.env.NODE_ENV == 'production') {
        this.$router.push({
            path: '/hubAuthorize',
            query: {scope: 'snsapi_userinfo'}
          })
        } else {
          this.$router.push({
            path: '/authorize',
            query: {scope: 'snsapi_userinfo'}
          })
        }
      } else {
        this.$router.push('/JNJUser');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #F5F5F5, #DEDEDE);
  padding: 15px 30px;
  box-sizing: border-box;
}
.logo {
  width: 128px;
  display: block;
  margin: 50px auto 40px;
  border-radius: 50%;
}
.tip {
  font-size: 18px;
  color: #8A8A8A;
  text-align: center;;
}
.goRegister {
  display: flex;
  align-items: center;
  height: 75px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  margin: 50px 0 15px;
  .icon {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 25px;
    img {
      width: 24px;
    }
  }
  .icon::after {
    content: "";
    width: 1px;
    height: 45px;
    background-color: rgba(202, 202, 202, 0.5);
    position: absolute;
    top: 15px;
    right: 0px;
  }
  .text {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    font-size: 16px;
    color: #3A3A3A;
    padding: 0 16px;
    .textBold {
      font-weight: bold;
    }
    img {
      width: 14px;
      height: 7px;
      transform: rotate(-90deg);
    }
    .registerBtn {
      color: #888888;
    }
  }
}
.clause {
  font-size: 13px;
  color: #666666;
  margin: 65px 0 15px;
  span {
    color: $themeColor;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right,rgba(176, 176, 176, 0) 0%,rgba(176, 176, 176, 0.5) 50%,rgba(176, 176, 176, 0) 100%);
  margin: 40px 0;
}
.btnBox {
  display: flex;
  justify-content: space-between;
  .btn {
    display: inline-block;
    width: 150px;
    height: 52px;
    line-height: 52px;
    border-radius: 4px;
    font-size: 16px;
    text-align: center;
    color: #8A8A8A;
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  }
}
</style>